import React, { useEffect } from "react";
import AOS from "aos";

// CSS
import "aos/dist/aos.css";

// Components
import Card from "../components/Card";

// Utils
import {
  CLUB_MEMBERS_2024_2025,
  CLUB_MEMBERS_2025_2026,
  MENTORS_2023_2024,
  MENTORS,
} from "../utils/data/club-members";

// Material-UI Components
import { Grid, Box, Typography } from "@mui/material";

export default function MembersPage() {
  const mentors = [...MENTORS_2023_2024, ...MENTORS];
  const club_members = [...CLUB_MEMBERS_2024_2025, ...CLUB_MEMBERS_2025_2026];

  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: "ease-in-out",
      once: true,
    });
  }, []);

  return (
    <>
      <Box data-aos="fade-up" sx={{ m: 6 }}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <Typography
            variant="h3"
            color="white"
            sx={{
              bgcolor: "rgba(255, 255, 255, 0.08)",
              px: 2,
              borderRadius: 2,
            }}
          >
            Our team
          </Typography>
          <div
            data-aos="fade-up"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              height: "100%",
            }}
          >
            <Grid container>
              {club_members.map((member, index) => (
                <Grid
                  key={index}
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={4}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Card member={member} />
                </Grid>
              ))}
            </Grid>
          </div>
          <Box sx={{ mb: 10 }}>&nbsp;</Box>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <Typography
            variant="h3"
            color="white"
            sx={{
              bgcolor: "rgba(255, 255, 255, 0.08)",
              px: 2,
              borderRadius: 2,
            }}
          >
            Mentors
          </Typography>
          <div
            data-aos="fade-up"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              height: "100%",
            }}
          >
            <Grid container>
              {mentors.map((member, index) => (
                <Grid
                  key={index}
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={4}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Card member={member} />
                </Grid>
              ))}
            </Grid>
          </div>
        </div>
      </Box>
    </>
  );
}
